(() => {
  const SECTION_SELECTOR = '.pasquini-collection-info';
  const CLAMPED_CLASS = 'pasquini-collection-info__description--clamped';
  const CLAMP_LINES = 3;

  const getClampHeight = (description) => {
    const lineHeight = parseFloat(getComputedStyle(description).lineHeight) || 0;
    return lineHeight * CLAMP_LINES;
  };

  const initToggle = (root) => {
    const description = root.querySelector('[data-description]');
    const toggle = root.querySelector('[data-description-toggle]');
    const label = root.querySelector('[data-description-toggle-label]');

    if (!description || !toggle || !label || toggle.dataset.bound === 'true') return;

    let expanded = false;
    description.style.maxHeight = `${getClampHeight(description)}px`;

    toggle.addEventListener('click', () => {
      expanded = !expanded;
      toggle.setAttribute('aria-expanded', String(expanded));
      label.textContent = expanded ? 'Ler menos' : 'Ler mais';

      if (expanded) {
        description.classList.remove(CLAMPED_CLASS);
        description.style.maxHeight = `${description.scrollHeight}px`;
      } else {
        // Set an explicit starting height (in case the window was resized while
        // expanded) so the collapse transition has a real value to animate from.
        description.style.maxHeight = `${description.scrollHeight}px`;
        requestAnimationFrame(() => {
          description.classList.add(CLAMPED_CLASS);
          description.style.maxHeight = `${getClampHeight(description)}px`;
        });
      }
    });

    window.addEventListener('resize', () => {
      if (expanded) {
        description.style.maxHeight = `${description.scrollHeight}px`;
      } else {
        description.style.maxHeight = `${getClampHeight(description)}px`;
      }
    });

    description.classList.add(CLAMPED_CLASS);
    toggle.dataset.bound = 'true';
  };

  const initAll = () => {
    document.querySelectorAll(SECTION_SELECTOR).forEach(initToggle);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const sectionRoot =
      event.target.querySelector?.(SECTION_SELECTOR) || event.target.closest?.(SECTION_SELECTOR);
    if (sectionRoot) initToggle(sectionRoot);
  });
})();
